window.ER_LENS_COLOURS={
  "version": 2,
  "additionalPackages": [{
    "id": "polar-mr8",
    "type": "single",
    "group": "Sunglass lenses",
    "name": "MR-8 Polarized Lenses – 1.60 index",
    "material": "MR-8 · 1.60",
    "fee": null,
    "feature": "polarized",
    "description": "Polarized lenses. Refractive index and price to be confirmed.",
    "priceStatus": "quote-required",
    "indexStatus": "pending-confirmation",
    "source": "user-requested-local-preview-only"
  }, {
    "id": "progressive-polar-mr8",
    "type": "progressive",
    "group": "Sunglass lenses",
    "name": "MR-8 Progressive Polarized Lenses – 1.60 index",
    "material": "MR-8 · 1.60",
    "fee": null,
    "feature": "polarized",
    "description": "Progressive polarized lenses. Refractive index, fitting range and price to be confirmed.",
    "priceStatus": "quote-required",
    "indexStatus": "pending-confirmation",
    "source": "user-requested-local-preview-only"
  }, {
    "id": "polar-trivex",
    "type": "single",
    "group": "Sunglass lenses",
    "name": "Trivex Polarized Lenses – 1.53 index",
    "material": "Trivex · 1.53",
    "fee": 8100,
    "feature": "polarized",
    "description": "Trivex polarized lenses. Supplier availability and frame compatibility to be confirmed before production.",
    "priceStatus": "market-informed-preview",
    "availabilityStatus": "pending-confirmation",
    "source": "local-preview-combination-pending-supplier-details"
  }, {
    "id": "photo-mr7",
    "type": "single",
    "group": "Photochromic lenses",
    "name": "MR7 Photochromic Lenses – 1.67 index",
    "material": "MR7 · 1.67",
    "fee": 6900,
    "feature": "photochromic",
    "description": "MR7 photochromic lenses. Supplier availability and frame compatibility to be confirmed before production.",
    "priceStatus": "market-informed-preview",
    "availabilityStatus": "pending-confirmation",
    "source": "local-preview-combination-pending-supplier-details"
  }],
  "referenceAsset": (window.ERTheme.assetRoot+"er-ui-lens-colour-reference-20261102.jpg"),
  "referenceWidth": 2246,
  "referenceHeight": 1586,
  "options": [
    {
      "id": "photo-silver",
      "group": "photochromic",
      "label": "Silver Mirror",
      "sourceLabel": "白水银",
      "before": [
        232,
        344,
        215,
        220
      ],
      "after": [
        232,
        642,
        215,
        220
      ],
      "detail": "Photochromic finish",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "photo-gold-brown",
      "group": "photochromic",
      "label": "Gold / Brown Mirror",
      "sourceLabel": "茶金水银",
      "before": [
        477,
        344,
        215,
        220
      ],
      "after": [
        477,
        642,
        215,
        220
      ],
      "detail": "Photochromic finish",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "photo-red",
      "group": "photochromic",
      "label": "Red Mirror",
      "sourceLabel": "红水银",
      "before": [
        722,
        344,
        215,
        220
      ],
      "after": [
        722,
        642,
        215,
        220
      ],
      "detail": "Photochromic finish",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "photo-purple",
      "group": "photochromic",
      "label": "Purple Mirror",
      "sourceLabel": "紫水银",
      "before": [
        967,
        344,
        215,
        220
      ],
      "after": [
        967,
        642,
        215,
        220
      ],
      "detail": "Photochromic finish",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "photo-blue",
      "group": "photochromic",
      "label": "Blue Mirror",
      "sourceLabel": "蓝水银",
      "before": [
        1212,
        344,
        215,
        220
      ],
      "after": [
        1212,
        642,
        215,
        220
      ],
      "detail": "Photochromic finish",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "photo-green",
      "group": "photochromic",
      "label": "Green Mirror",
      "sourceLabel": "绿色水银（色卡第6列）",
      "before": [
        1457,
        344,
        215,
        220
      ],
      "after": [
        1457,
        642,
        215,
        220
      ],
      "detail": "Photochromic finish",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "photo-enhanced",
      "group": "photochromic",
      "label": "Enhanced Photochromic",
      "sourceLabel": "变色强化",
      "before": [
        1702,
        344,
        215,
        220
      ],
      "after": [
        1702,
        642,
        215,
        220
      ],
      "detail": "Photochromic finish",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "polar-silver",
      "group": "polarized",
      "label": "Silver Mirror + USH",
      "sourceLabel": "偏光灰底 白水银+USH",
      "image": [
        312,
        1190,
        190,
        176
      ],
      "detail": "Grey-base polarized lens",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "polar-red",
      "group": "polarized",
      "label": "Red Mirror + USH",
      "sourceLabel": "偏光灰底 红水银+USH",
      "image": [
        730,
        1190,
        190,
        176
      ],
      "detail": "Grey-base polarized lens",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "polar-blue",
      "group": "polarized",
      "label": "Blue Mirror + USH",
      "sourceLabel": "偏光灰底 蓝水银+USH",
      "image": [
        1140,
        1190,
        190,
        176
      ],
      "detail": "Grey-base polarized lens",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "polar-photo-enhanced",
      "group": "polarized",
      "label": "Solid Polarized Grey",
      "sourceLabel": "偏光灰底 变色强化+USH",
      "image": [
        1550,
        1190,
        190,
        176
      ],
      "detail": "Fixed grey tint · Non-mirrored · Non-photochromic",
      "specificationStatus": "user-confirmed",
      "photochromic": false,
      "mirror": false,
      "specificationSource": "User confirmed fixed polarized grey, without a mirror finish or photochromism.",
      "priceAdjustmentMinor": 0
    },
    {
      "id": "clear",
      "group": "clear",
      "label": "Clear",
      "sourceLabel": "透明镜片",
      "detail": "Clear lens",
      "swatch": "linear-gradient(135deg,#fff,#e7eff0,#fff)",
      "priceAdjustmentMinor": 0
    }
  ],
  "featureGroups": {
    "photochromic": "photochromic",
    "polarized": "polarized",
    "clear": "clear",
    "tinted": "tinted"
  },
  "defaultChoices": {
    "clear": "clear"
  },
  "referenceOnly": true,
  "compatibilityStatus": "preview mapping pending user confirmation",
  "pricingBasis": "Existing source fees plus user-authorized market-informed preview prices; colour surcharges not supplied"
};
// Correct customer-facing labels while retaining source IDs, fees and snapshots.
window.ERNormalizeLensPackage = pack => {
  const corrected = {...pack};
  corrected.material = corrected.material
    .replace('Polycarbonate · 1.67', 'MR7 · 1.67')
    .replace('High-Index · 1.67', 'MR7 · 1.67')
    .replace('MR8 · 1.61', 'MR-8 · 1.60')
    .replace('MR-7 · 1.67', 'MR7 · 1.67');
  if (corrected.material === 'Trivex') corrected.material = 'Trivex · 1.53';
  corrected.name = corrected.name.replace(/MR8/g, 'MR-8').replace(/MR-?7/g, 'MR7');
  if (corrected.name.includes('MR-8')) corrected.name = corrected.name.replace(/1\.61/g, '1.60');
  if (corrected.id === 'polar-thin') corrected.name = 'MR7 Polarized Lenses – Thin 1.67';
  if (corrected.id === 'photo-trivex') corrected.name = 'Trivex Photochromic Lenses – 1.53 index';
  return corrected;
};
window.ERLensPackagesFor = product => [...product.packages, ...window.ER_LENS_COLOURS.additionalPackages].map(window.ERNormalizeLensPackage);
